<template>
  <div id="app" :style="hiddenStyle">
    <!-- Slider main container -->
    <div class="swiper-container">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!-- Slides -->
            <div class="swiper-slide">
              <div id="slide1" class="h-100" :style="{ backgroundImage: `url(${firstBg})`, backgroundSize:'cover'}">
                <div class="container h-100">
                  <div class="row h-100 align-items-md-center">
                    <div class="col-sm fixed-bottom">
                        <div><b-img id="man-pic" src="/pr/images/man.png" fluid height="50%"></b-img></div>
                    </div>
                    <div class="col-sm econ-font-sub-title text-white text-center">
                      <div class="mt-5">
                        <p id="slide1Word" class="econ-font-sub-title "><span class="rounded-lg bg-light px-4 py-2 text-body">รู้หรือไม่</span></p>
                        <p id="slide1Text1">ผู้บริหารบริษัทเอกชนญี่ปุ่นจำนวนมากเรียนจบเศรษฐศาสตร์
                          <!-- <br>
                          <span class="econ-font-small">อ้างอิง: Toyokeizai Shinposha, Yakuin Shikibo. 2000.</span> -->
                        </p>
                        <div>
                          <div class="dot mr-2 dot1"></div>
                          <div class="dot mr-2 dot2"></div>
                          <div class="dot dot3"></div>
                        </div>
                        
                      </div>
                      <div id="slide1Text2">โลกกำลังเปลี่ยนแปลงไปอย่างรวดเร็ว</div>
                      <div id="slide1Text3">วิชาเศรษฐศาสตร์กำลังวิวัฒนาการและปรับให้ทันโลก</div>
                      <div>
                        <div class="dot mr-2 dot4"></div>
                        <div class="dot mr-2 dot5"></div>
                        <div class="dot dot6"></div>
                      </div>
                      <!-- <div class="row justify-content-end">
                        <div class="col-10 econ-font-xsmall text-left font-italic">อ้างอิง:</div>
                      </div>
                      <div class="row justify-content-end">
                        <div class="col-10 econ-font-xsmall text-left font-italic">Toyokeizai Shinposha, Yakuin Shikibo. 2000.</div> -->
                        <div id="slide1Text4" class="align-self-end econ-font-xsmall text-right font-italic mr-3"><span>อ้างอิง:</span>
                        <br><span class="text-nowrap">Toyokeizai Shinposha, Yakuin Shikibo. 2000.</span></div>
                      <!-- </div> -->
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div id="slide2" class="h-100 gradientBg text-white">
              <!-- <div id="slide2" class="h-100 text-white"> -->
                <div class="h-100 slide2-bg" :style="{ backgroundImage: `url(${secondOverlayBg})`}">
                  <div class="container-fluid p-5 text-center h-100">
                    <div class="row h-100">
                      <div class="col pt-md-5 mt-md-5">
                        <div id="slide2Title" class="text-nowrap econ-font-normal econ-thin-font mb-2">
                          ถ้าคุณกำลังมองหา ...
                        </div>

                        <div id="slide2Cards" class="d-flex flex-wrap justify-content-center p-2 econ-font-small">
                        <!-- <div id="slide2Cards" class="col justify-content-center p-2 econ-font-small"> -->
                          <div id="to-slide-3" class="card m-1 mb-sm-2 m-lg-3 flex-fill py-lg-4 shadow econ-card-pointer" @click="onClick(2)">
                            <div  class="card-body">
                              <h5 class="card-title"><i class="fa fa-star"></i></h5>
                              <p class="card-text text-wrap">
                                  ทางเลือกในการเรียน<br>
                                  เพื่อการทำงานในอนาคต
                                </p>
                              <p @click="onClick(2)"><b-img src="/pr/images/Button.png" class="econ-button-click"></b-img></p>
                            </div>
                          </div>

                          <div id="to-slide-4" class="card m-1 mb-sm-2 m-lg-3 flex-fill py-lg-4 shadow econ-card-pointer" @click="onClick(3)">
                            <div class="card-body">
                              <h5 class="card-title"><i class="fa fa-star"></i></h5>
                              <p class="card-text text-wrap">
                                  เสริมสร้างความรู้<br>
                                  เพื่อความได้เปรียบในการแข่งขัน
                                </p>
                              <p @click="onClick(3)"><b-img src="/pr/images/Button.png" class="econ-button-click"></b-img></p>
                            </div>
                          </div>

                          <div  id="to-slide-5" class="card m-1 mb-sm-2 m-lg-3 flex-fill py-lg-4 shadow econ-card-pointer" @click="onClick(4)">
                            <div class="card-body">
                              <h5 class="card-title"><i class="fa fa-star"></i></h5>
                              <p class="card-text text-wrap">
                                  รูปแบบการเรียน<br>ที่ลงตัวกับชีวิต
                                </p>
                              <p @click="onClick(4)"><b-img src="/pr/images/Button.png" class="econ-button-click"></b-img></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div id="slide3" class="h-100">
                <div class="h-100 slide3-bg" :style="{ backgroundImage: `url(${firstChoiceBg})`}">
                  <div class="container-fluid h-100 text-center">
                    <div class="row h-100 justify-content-center">
                        <div class="col col-md-7 col-lg-8 align-self-center">
                          <div id="slide3Content" class="shadow p-3 econ-font-normal econ-transparent"> 
                            <p id="slide3Paragraph1" class="">
                              <span class="gradient-text econ-animated-word ">วิชาเศรษฐศาสตร์</span> คือ ศาสตร์ของการใช้ทรัพยากร ทุกองค์กร ทั้งภาครัฐ เอกชน และรัฐวิสาหกิจ
                              ต่างต้องการการจัดการทรัพยากร ทั้งคน เงิน เวลา ฯลฯ ให้มีคุณค่ามากที่สุด
                            </p>
                            <p id="slide3Paragraph2">
                            ปัจจุบัน ภาครัฐ เอกชน รัฐวิสาหกิจ และหน่วยวิจัย ต่างมีตำแหน่งที่ต้องการความรู้ด้านเศรษฐศาสตร์ เพื่อใช้วิเคราะห์นโยบายและแผนขององค์กร
                            </p>
                            <p id="slide3Paragraph3">
                              และหากคำถามคุณ คือ “จะเลือกเรียนวิชาเศรษฐศาสตร์ที่ใด”
                            </p>
                            <p id="slide3Paragraph4" @click="onClick(5)"><b-img src="/pr/images/Button.png" class="econ-button-click"></b-img></p>
                          </div>
                          
                        </div>
                        
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div id="slide4" class="h-100">
                <div class="h-100 slide4-bg" :style="{ backgroundImage: `url(${secondChoiceBg})`}">
                  <div class="container-fluid h-100 text-center">
                    <div class="row h-100 justify-content-center">
                        <!-- <div class="col col-md-6 col-lg-7 align-self-center text-white"> -->
                        <div class="col col-md-7 col-lg-8 align-self-center">
                          <div id="slide4Content" class="shadow p-3 m-lg-5 econ-font-normal econ-transparent"> 
                            <p id="slide4Paragraph1" class="">หากคุณมีงานประจำที่ทำอยู่ แต่ต้องการเพิ่มทางเลือกให้ชีวิตดีขึ้น</p>

                            <p id="slide4Paragraph2" class="">และใบปริญญาเป็น<span class="gradient-text">กุญแจ</span>สำคัญนั้น</p>

                            <p id="slide4Paragraph3" class="">หากการเรียนควบคู่กับการทำงานเป็นโจทย์สำคัญของคุณนั้น...</p>
                      
                            <p id="slide4Paragraph4" @click="onClick(5)"><b-img src="/pr/images/Button.png" class="econ-button-click"></b-img></p>
                          </div>
                          
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div id="slide5" class="h-100">
                <div class="h-100 slide5-bg" :style="{ backgroundImage: `url(${thirdChoiceOverlayBg})`}">
                  <div class="container-fluid h-100 text-center">
                    <!-- <div class="row h-100 justify-content-center justify-content-xl-end"> -->
                    <div class="row h-100 justify-content-center">
                        <!-- <div class="col col-md-7 col-lg-8 align-self-start align-self-xl-center"> -->
                        <div class="col col-md-7 col-lg-8 align-self-center">
                        <!-- <div class="col col-md-7 col-lg-7 align-md-self-center"> -->
                          <div id="slide5Content" class="shadow-lg p-3 m-4 m-lg-5 econ-font-normal"> 

                            <p id="slide5Paragraph1" class="">ในสังคมที่กำลังแข่งขันกันสูงขึ้นเรื่อยๆ ความรอบรู้ในหลายสาขาวิชา จะทำให้คุณโดดเด่นในการแข่งขัน 
                              และวิชาเศรษฐศาสตร์เป็น <span class="slide5-gradient-text">จิ๊กซอว์</span> ชิ้นสำคัญ ที่ช่วยเชื่อมโยงศาสตร์ต่างๆ ให้เท่าทันความเปลี่ยนแปลงของโลกได้อยู่เสมอ</p>

                            <p id="slide5Paragraph2">และถ้าคุณต้องการโอกาสเพื่อความได้เปรียบนั้น...</p>
                           
                            <p id="slide5Paragraph3" @click="onClick(5)"><b-img src="/pr/images/Button.png" class="econ-button-click"></b-img></p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div id="slide6" class="h-100">
                <div class="float-left m-3" style="position:absolute"> 
                  <b-img src="/pr/images/Logo_ram_w.png" class="univ-logo"></b-img>
                </div>
                <div class="h-100 slide6-bg" :style="{ backgroundImage: `url(${univBg})`}">
                  <div class="row h-100">
                    <!-- <div class="w-100 align-self-start">
                        <div id="slide6Logo">
                          <b-img src="./assets/images/Logo_ram_w.png" class="univ-logo ml-2 ml-md-5"></b-img>
                        </div>
                    </div>   -->
                    <div class="col-6 align-self-center">
                        <div id="slide6Pic">
                          <b-img src="/pr/images/first-univ-pic.png" class="univ-yellow-pic ml-2 ml-md-5"></b-img>
                        </div>
                    </div>  
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="swiper-slide">
              <div id="slide7" class="p-5 h-100" :style="{ backgroundImage: `url(${secondUnivBg})`}">
                <b-container fluid class="h-100">
                  <b-row>
                    <b-col>
                      <b-carousel
                        id="carousel-fade"
                        style="text-shadow: 0px 0px 2px #000"
                        fade
                        indicators
                        img-width="30"
                        img-height="30"
                      >
                        <b-carousel-slide
                          img-src="./assets/images/slides/1.jpg"
                        ></b-carousel-slide>
                        <b-carousel-slide
                          img-src="./assets/images/slides/2.jpg"
                        ></b-carousel-slide>
                        <b-carousel-slide
                          img-src="./assets/images/slides/3.jpg"
                        ></b-carousel-slide>
                        <b-carousel-slide
                          img-src="./assets/images/slides/4.jpg"
                        ></b-carousel-slide>
                        <b-carousel-slide
                          img-src="./assets/images/slides/5.jpg"
                        ></b-carousel-slide>
                      </b-carousel>
                    </b-col>
                 
                    <b-col>
                      <p>
                        เปิดสอนแนวคิดและทฤษฎีเศรษฐศาสตร์ด้านต่างๆ
                        ตลอดจนโครงสร้างระบบเศรษฐกิจทั้งในและต่างประเทศ ในรูปแบบตลาดวิชา สามารถเลือกเรียนวิชาที่สนใจได้
                        เพื่อตอบโจทย์การเรียนรู้ของผู้เรียน ผ่านกระบวนการฝึกคิด วิเคราะห์และแก้ไขปัญหาได้อย่างเป็นระบบ
                      </p>
                      <p>รายวิชาเปิดสอน (บางส่วน) เศรษฐศาสตร์จุลภาค มหภาค เครื่องมือทางสถิติสำหรับเศรษฐศาสตร์ เศรษฐศาสตร์รายสาขา เช่น การเกษตร อุตสาหกรรม ธุรกิจ การคลัง
                      การเงิน การธนาคาร การพัฒนา การขนส่งและโลจิสติกส์ พลังงาน
                        และวิชาที่กำลังได้รับความนิยม เช่น เศรษฐศาสตร์พฤติกรรม ทฤษฎีเกม</p>
                    </b-col>
                  
                  </b-row>
                </b-container> -->
                <!-- <div class="container-fluid h-100">
                  <div class="row h-50">
                    <div class="col">
                      
                        

                     
                    </div>
                  </div>
                  <div class="row h-50">
                    <div class="col">
                      <p>
                        เปิดสอนแนวคิดและทฤษฎีเศรษฐศาสตร์ด้านต่างๆ
                        ตลอดจนโครงสร้างระบบเศรษฐกิจทั้งในและต่างประเทศ ในรูปแบบตลาดวิชา สามารถเลือกเรียนวิชาที่สนใจได้
                        เพื่อตอบโจทย์การเรียนรู้ของผู้เรียน ผ่านกระบวนการฝึกคิด วิเคราะห์และแก้ไขปัญหาได้อย่างเป็นระบบ
                      </p>
                      <p>รายวิชาเปิดสอน (บางส่วน) เศรษฐศาสตร์จุลภาค มหภาค เครื่องมือทางสถิติสำหรับเศรษฐศาสตร์ เศรษฐศาสตร์รายสาขา เช่น การเกษตร อุตสาหกรรม ธุรกิจ การคลัง
                      การเงิน การธนาคาร การพัฒนา การขนส่งและโลจิสติกส์ พลังงาน
                        และวิชาที่กำลังได้รับความนิยม เช่น เศรษฐศาสตร์พฤติกรรม ทฤษฎีเกม</p>
                    </div>
                    
                  </div>
                </div> -->
              <!-- </div>
            </div> -->

            <div class="swiper-slide">
              <div id="slide7" class="h-100 yellow-bg">
               <div class="h-100 slide8-bg" :style="{ backgroundImage: `url(${labtopOverlayBg})`}">
                  <div class="container-fluid h-100">
                    <div id="slide8Content" class="row h-100 justify-content-center justify-content-lg-end">
                        <div class="col col-md-7 col-lg-7 mt-5 mt-lg-0 align-self-lg-center">
                          <div class="row mb-3"> 
                            <div id="slide8Title" class="col text-center">
                              <span class="econ-purple-font econ-font-sub-title">คณะเศรษฐศาสตร์<br></span>
                              <span class="econ-font-normal">มหาวิทยาลัยรามคำแหง<br></span>
                              <span class="econ-purple-font econ-font-normal">เป็นทางเลือกที่ดีกว่า...<br></span>
                            </div>
                          </div>
                          <div class="row"> 
                            <div class="col-12 col-xl-6" id="ani-icon1">
                              <div class="d-flex flex-row flex-nowrap m-2" >
                                <b-img src="/pr/images/ICON1.png" class="icon-pic"></b-img>
                                <div>
                                  <span class="econ-font-normal econ-purple-font">ตั้งใจจริงผ่านได้ใน 3 ปี</span><br>
                                  <span class="econ-thin-font">หากสามารถสะสมหน่วยกิตครบ<br>ตามที่หลักสูตรกำหนด</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-xl-6" id="ani-icon2">
                              <div class="d-flex flex-row flex-nowrap m-2" >
                                <!-- <div> -->
                                  <b-img src="/pr/images/ICON2.png" class="icon-pic"></b-img>
                                <!-- </div> -->
                                <div>
                                  <span class="econ-font-normal econ-purple-font">เริ่มเรียนได้ก่อน</span><br>
                                  <!--<span class="econ-thin-font">สามารถลงทะเบียนสะสมหน่วยกิต<br>ได้ตั้งแต่ระดับมัธยมศึกษาปีที่ 4</span> -->
                                  <span class="econ-thin-font">สามารถลงทะเบียนสะสมหน่วยกิต<br>ได้ตั้งแต่ชั้น ม.4 (Pre-degree)</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-xl-6" id="ani-icon3">
                              <div class="d-flex flex-row flex-nowrap m-2" >
                                <!-- <div> -->
                                  <b-img src="/pr/images/ICON3.png" class="icon-pic"></b-img>
                                <!-- </div> -->
                                <div>
                                  <span class="econ-font-normal econ-purple-font">วางแผนจัดการชีวิตง่ายกว่า</span><br>
                                  <span class="econ-thin-font">สามารถเรียนควบคู่กับทำงาน<br>หรือการเรียนในสาขา/มหาวิทยาลัยอื่น</span>
                                
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-xl-6" id="ani-icon4">
                              <div class="d-flex flex-row flex-nowrap m-2" >
                                <!-- <div> -->
                                  <b-img src="/pr/images/ICON4.png" class="icon-pic"></b-img>
                                <!-- </div> -->
                                <div>
                                  <span class="econ-font-normal econ-purple-font">ค่าใช้จ่ายต่ำ</span><br>
                                  <span class="econ-thin-font">ค่าใช้จ่ายไม่แพง<br>เพียงหน่วยกิตละ 25 บาท</span>

                                </div>
                              </div>
                            </div>
                            <!-- </div> -->
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div id="slide8" class="p-3 h-100">
                <div class="h-100 slide9-bg" :style="{ backgroundImage: `url(${slide9Bg})`}">
                  <div class="container-fluid h-100">
                    <div class="row h-100 justify-content-center">
                      <div class="col-10 align-self-center">
                        <div id="slide9Title" class="text-center mt-5 mt-lg-0 mb-3 pt-5 pt-lg-0">
                          <span class="econ-font-normal">เริ่มต้นเส้นทางสู่<br></span>
                          <span class="econ-purple-font econ-font-sub-title">คณะเศรษฐศาสตร์<br></span>
                          <span class="econ-font-normal">มหาวิทยาลัยรามคำแหง<br></span>
                        </div>
                        <div class="row justify-content-center">
                          <div id="slide9Icon1" class="col-4 col-md-6 col-xl-2">
                            <div  class="d-flex flex-column align-items-center">
                             
                              <a href="https://goo.gl/maps/uH5gpKUmLYYzN9FD6" target="_blank"><b-img src="/pr/images/ICON5.png" class="icon-purple-pic"></b-img></a>
                          
                              <div class="text-center econ-thin-font">
                                แผนที่
                              </div>
                            </div>
                          </div>
                          <div id="slide9Icon2" class="col-4 col-md-6 col-xl-2">
                            <div class="d-flex flex-column align-items-center">
                              <!-- <div> -->
                              <a href="http://www.eco.ru.ac.th" target="_blank"><b-img src="/pr/images/ICON6.png" class="icon-purple-pic"></b-img> </a>
                              <!-- </div> -->
                              <div class="text-center econ-thin-font">
                                เว็บไซต์
                              </div>
                            </div>
                          </div>
                          <div class="w-0"></div>
                          <!-- <div id="slide9Icon3" class="col-6 col-lg-2"> -->
                          <div id="slide9Icon3" class="col-4 col-md-6 col-xl-2">
                            <div class="d-flex flex-column align-items-center">
                              <!-- <div> -->
                              <a href="https://www.facebook.com/%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C-%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B8%A3%E0%B8%B2%E0%B8%A1%E0%B8%84%E0%B8%B3%E0%B9%81%E0%B8%AB%E0%B8%87-985479024795589/" target="_blank"><b-img src="/pr/images/ICON7.png" class="icon-purple-pic"></b-img></a>
                              <!-- </div> -->
                              <div class="text-center econ-thin-font">
                                Facebook
                              </div>
                            </div>
                          </div>
                          <!-- <div  id="slide9Icon4" class="col-6 col-lg-2"> -->
                          <div  id="slide9Icon4" class="col-4 col-md-6 col-xl-2">
                            <div class="d-flex flex-column align-items-center">
                              <!-- <div> -->
                              <b-img src="/pr/images/ICON8.png" class="icon-purple-pic"></b-img>
                              <!-- </div> -->
                              <div class="text-center econ-thin-font text-nowrap">
                                โทรศัพท์<br>
                                <a href="tel:+6623108534" class="text-muted">02-310-8534</a><br>
                                <a href="tel:+6623108528" class="text-muted">02-310-8528</a>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="w-0"></div> -->
                          <div  id="slide9Icon5" class="col-4 col-md-6 col-xl-2">
                            <div class="d-flex flex-column align-items-center">
                              <a href="https://sites.google.com/rumail.ru.ac.th/suggestion/" target="_blank"> 
                              <b-img src="/pr/images/Icon_Apply.png" class="icon-apply-pic"></b-img>
                              </a>
                              <div class="text-center econ-thin-font">
                                สมัครเรียนทันที
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- If we need pagination -->
        <div class="swiper-pagination"></div>

        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>

        <!-- If we need scrollbar -->
        <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
// import UIkit from 'uikit';
// import Icons from 'uikit/dist/js/uikit-icons';
// UIkit.use(Icons);
import firstBg from '@/assets/images/main-background_optimized.jpg'
import secondBg from '@/assets/images/question-background-2.png'
import secondOverlayBg from '@/assets/images/Page2.png'
import firstChoiceBg from '@/assets/images/first-modal-background-optimized.jpg'
import secondChoiceBg from '@/assets/images/second-modal-background.jpg'
import thirdChoiceOverlayBg from '@/assets/images/third-modal-background.png'
import univBg from '@/assets/images/first-univ-bg.jpg'
import secondUnivBg from '@/assets/images/second-univ-bg.png'
import labtopOverlayBg from '@/assets/images/laptop-background.png'
import slide9Bg from '@/assets/images/Page6.png'

import man from '@/assets/images/man.png'
import uni from '@/assets/images/uni_name.jpg'

export default {
  name: 'App',
  data () {
    return {
      firstBg,
      secondBg,
      secondOverlayBg,
      firstChoiceBg,
      secondChoiceBg,
      thirdChoiceOverlayBg,
      univBg,
      secondUnivBg,
      labtopOverlayBg,
      uni,
      slide9Bg,
      // thirdChoiceBg,
      // animatedBg: {
      //   'animated': false,
      //   'fadeIn': false,
      //   // 'duration'
      // },
      swiper: null,
      hiddenStyle: {
        visibility: 'hidden'
      },
      // publicPath: process.env.BASE_URL
    }
  },
  beforeMount () {
    let self = this;
    window.addEventListener('load', (event) => {
      console.log('page is fully loaded');
      self.hiddenStyle = {
        visibility: 'visible'
      }

      self.animateCSS('#man-pic', ['slideInUp']);
      self.animateCSS('#slide1Word', ['flipInX', 'delay-0-5', 'duration-2']);
      self.animateCSS('.dot1', ['fadeIn', 'delay-0-5']);
      self.animateCSS('.dot2', ['fadeIn', 'delay-1']);
      self.animateCSS('.dot3', ['fadeIn', 'delay-1-5']);
      self.animateCSS('.dot4', ['fadeIn', 'delay-0-5']);
      self.animateCSS('.dot5', ['fadeIn', 'delay-1']);
      self.animateCSS('.dot6', ['fadeIn', 'delay-1-5']);
      self.animateCSS('#slide1Text1', ['fadeIn', 'delay-0-5']);
      self.animateCSS('#slide1Text2', ['fadeIn', 'delay-1']);
      self.animateCSS('#slide1Text3', ['fadeIn', 'delay-1-5']);
      self.animateCSS('#slide1Text4', ['fadeIn', 'delay-2']);
    });
  },
  mounted () {
    var mySwiper = new Swiper ('.swiper-container', {
      // Optional parameters
      direction: 'vertical',
      // loop: true,
      parallax: true,
      mousewheel: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      // scrollbar: {
      //   el: '.swiper-scrollbar',
      // },
      on: {
        init: function () {
          console.log('swiper initialized');
        },
      },
    })

    this.swiper = mySwiper;

    // this.animateCSS('#man-pic', ['slideInUp']);
    // this.animateCSS('#slide1Word', ['flipInX', 'delay-0-5', 'duration-2']);
    // this.animateCSS('.dot1', ['fadeIn', 'delay-0-5']);
    // this.animateCSS('.dot2', ['fadeIn', 'delay-1']);
    // this.animateCSS('.dot3', ['fadeIn', 'delay-1-5']);
    // this.animateCSS('.dot4', ['fadeIn', 'delay-0-5']);
    // this.animateCSS('.dot5', ['fadeIn', 'delay-1']);
    // this.animateCSS('.dot6', ['fadeIn', 'delay-1-5']);
    // this.animateCSS('#slide1Text1', ['fadeIn', 'delay-0-5']);
    // this.animateCSS('#slide1Text2', ['fadeIn', 'delay-1']);
    // this.animateCSS('#slide1Text3', ['fadeIn', 'delay-1-5']);
    let self = this;
    mySwiper.on('slideChange', function () {
      // console.log('slide changed');
      self.animateCSS(`#slide${mySwiper.activeIndex+1}`, ['fadeIn', 'animatedBg']);
      self.assignAnimation(mySwiper.activeIndex);
    });
  },
  methods: {  
    onClick: function (index) {
      console.log('click', index);
      this.swiper.slideTo(index, 1000, false);
    },
    toggleAnimation: function() {
      console.log(index);
    },

    animateCSS: function (element, animationArr, callback) {
      const node = this.$el.querySelector(element);
      node.classList.add('animated');

      for (let index = 0; index < animationArr.length; index++) {
        const element = animationArr[index];
        node.classList.add(element);
      }
      
      function handleAnimationEnd() {
          node.classList.remove('animated');
          for (let index = 0; index < animationArr.length; index++) {
            const element = animationArr[index];
            node.classList.remove(element)
          }
          node.removeEventListener('animationend', handleAnimationEnd)

          if (typeof callback === 'function') callback()
      }

      node.addEventListener('animationend', handleAnimationEnd)
    },

    assignAnimation: function(slideIndex) {
      switch(slideIndex) {
        case 0:
          // code block
          this.animateCSS('#man-pic', ['slideInUp']);
          this.animateCSS('#slide1Word', ['flipInX', 'delay-0-5', 'duration-2']);
          this.animateCSS('.dot1', ['fadeIn', 'delay-0-5']);
          this.animateCSS('.dot2', ['fadeIn', 'delay-1']);
          this.animateCSS('.dot3', ['fadeIn', 'delay-1-5']);
          this.animateCSS('.dot4', ['fadeIn', 'delay-0-5']);
          this.animateCSS('.dot5', ['fadeIn', 'delay-1']);
          this.animateCSS('.dot6', ['fadeIn', 'delay-1-5']);
          this.animateCSS('#slide1Text1', ['fadeIn', 'delay-0-5']);
          this.animateCSS('#slide1Text2', ['fadeIn', 'delay-1']);
          this.animateCSS('#slide1Text3', ['fadeIn', 'delay-1-5']);
          this.animateCSS('#slide1Text4', ['fadeIn', 'delay-2']);
          break;
        case 1:
          this.animateCSS('#slide2Title', ['zoomIn', 'delay-0-5']);
          this.animateCSS('#to-slide-3', ['zoomIn', 'delay-0-5', 'duration-1']);
          this.animateCSS('#to-slide-4', ['zoomIn', 'delay-1', 'duration-1']);
          this.animateCSS('#to-slide-5', ['zoomIn', 'delay-1-5', 'duration-1']);
          break;
        case 2: 
          this.animateCSS('#slide3Content', ['slideInLeft', 'delay-0-5']);
          this.animateCSS('#slide3Paragraph1', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide3Paragraph2', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide3Paragraph3', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide3Paragraph4', ['slideInLeft', 'delay-07']);
          this.animateCSS('.econ-animated-word', ['slideInLeft', 'delay-07']);
          // this.animateCSS('.econ-animated-word', ['zoomIn', 'delay-1-5', 'duration-2']);
          break;
        case 3: 
          // this.animateCSS('#slide4Content', ['slideInUp', 'delay-0-5']);
          // this.animateCSS('#slide4Paragraph3', ['slideInLeft', 'delay-0-5']);
          // this.animateCSS('#slide4Jigsaw', ['bounceIn', 'delay-1-5', 'duration-2']);
          this.animateCSS('#slide4Content', ['slideInLeft', 'delay-0-5']);
          this.animateCSS('#slide4Paragraph1', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide4Paragraph2', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide4Paragraph3', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide4Paragraph4', ['slideInLeft', 'delay-07']);
          // this.animateCSS('#slide4Jigsaw', ['bounceIn', 'delay-1-5', 'duration-2']);
          break;
        case 4: 
          this.animateCSS('#slide5Content', ['slideInLeft', 'delay-0-5']);
          this.animateCSS('#slide5Paragraph1', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide5Paragraph2', ['slideInLeft', 'delay-07']);
          this.animateCSS('#slide5Paragraph3', ['slideInLeft', 'delay-07']);
          // this.animateCSS('#slide5Word', ['fadeIn', 'delay-1-5', 'duration-2']);
          break;
        case 5: 
          this.animateCSS('#slide6Pic', ['zoomIn', 'delay-0-5', 'duration-2']);
          break;
        // case 7: 
        case 6:
          this.animateCSS('#slide8Title', ['fadeIn', 'delay-0-5']);
          this.animateCSS('#ani-icon1', ['fadeIn', 'delay-07']);
          this.animateCSS('#ani-icon2', ['fadeIn', 'delay-07']);
          this.animateCSS('#ani-icon3', ['fadeIn', 'delay-1']);
          this.animateCSS('#ani-icon4', ['fadeIn', 'delay-1']);
          break;
        // case 8: 
        case 7:
          this.animateCSS('#slide9Title', ['zoomIn', 'delay-0-5']);
          this.animateCSS('#slide9Icon1', ['flipInX', 'delay-0-5']);
          this.animateCSS('#slide9Icon2', ['flipInX', 'delay-1']);
          this.animateCSS('#slide9Icon3', ['flipInX', 'delay-1-5']);
          this.animateCSS('#slide9Icon4', ['flipInX', 'delay-2']);
          this.animateCSS('#slide9Icon5', ['flipInX', 'delay-2-5']);
          break;
        default:
          // code block
      }
    }
  }
};
</script>

<style>

.opacity-text {
  opacity: 0.5;
}

.dot {
        height: 15px;
        width: 15px;
        background-color: white;
        border-radius: 50%;
        display: inline-block;
    }

.swiper-container {
  width: 100%;
  height: 100vh;
}
.animatedBg {
  animation-duration: 2s;
  /* animation-delay: 1s; */
  /* animation-iteration-count: infinite; */
}
.duration-2 {
  animation-duration: 2s;
}
.delay-0-5 {
  animation-delay: 0.5s;
}
.delay-07 {
  animation-delay: 0.7s;
}
.delay-09 {
  animation-delay: 0.9s;
}
.delay-1 {
  animation-delay: 1s;
}
.delay-1-5 {
  animation-delay: 1.5s;
}
.delay-2 {
  animation-delay: 2s;
}
.delay-2-5 {
  animation-delay: 2.5s;
}
.delay-3 {
  animation-delay: 3s;
}
.gradient-text {
  /* background: linear-gradient(to right, #30CFD0 0%, #330867 100%); */
  background: linear-gradient(to right, #014579 0%, #008c91 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

.slide4-gradient-text {
  background: linear-gradient(to right, #FDC830 0%, #F37335 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

.slide5-gradient-text {
  background: linear-gradient(to right, #FF4E50 0%, #F9D423 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

#slide2.gradientBg {
  /* background: linear-gradient(306deg, #5d33df, #8340d0, #b365d7); */
  /* background: linear-gradient(306deg, #370f83, #4215a9, #4919c7);
  background-size: 600% 600%;

  -webkit-animation: AnimationName 11s ease infinite;
  -moz-animation: AnimationName 11s ease infinite;
  animation: AnimationName 11s ease infinite; */
  background: #370f83;
}

/* .swiper-button-next {
  top: 95% !important;
  transform: rotate(90deg) !important;
  right: 30px !important;
  left: auto !important;
  background-size: 85% !important;
}


.swiper-button-prev {
  top: 90% !important;
  transform: rotate(90deg) !important;
  right: 30px !important;
  left: auto !important;
  background-size: 85% !important;
} */

@-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@keyframes AnimationName { 
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
</style>


<style lang="less">
// @import "../node_modules/uikit/src/less/uikit.less";
// @import "./assets/less/theme.less";
</style>

<style lang="scss">
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif, 'Chonburi', cursive;
  // font-family: 'Chonburi', cursive;
  // font-family: 'Mitr', sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  font-family: 'DB HelvethaicaMon X Bd Cond', 'CS ChatThaiUI Regular', sans-serif;
}
</style>
